export default {
  name: "Download",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M10.29 15.71a.996.996 0 1 1 1.41-1.41l3.3 3.29V4c0-.55.45-1 1-1s1 .45 1 1v13.59l3.29-3.29a.996.996 0 1 1 1.41 1.41l-5 5c-.37.39-1.04.39-1.42 0l-4.99-5zM28 13c-.55 0-1 .45-1 1v13H5V14c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V14c0-.55-.45-1-1-1z",
  },
}
